import { jsxs as M, jsx as r } from "react/jsx-runtime";
import { useState as b, useMemo as O, useEffect as T, useRef as N } from "react";
import { Markdown as I, PageFooter as j, Button as E, Notification as B, SelectList as H, Box as D } from "@quark/design";
import v from "lodash";
import { useDrop as L, useDrag as P, DndProvider as Q } from "react-dnd";
import Y from "immutability-helper";
import { HTML5Backend as $ } from "react-dnd-html5-backend";
const k = ({
  children: l,
  onPrev: t,
  title: e,
  content: o,
  renderAction: m,
  unLocker: u,
  isRight: s,
  stage: n
}) => /* @__PURE__ */ M("div", { className: "container", children: [
  /* @__PURE__ */ r("h2", { children: e }),
  o && /* @__PURE__ */ r(I, { children: o }),
  l,
  (() => {
    if (s === !0 && n === "submitted")
      return /* @__PURE__ */ r(
        B,
        {
          message: "答案正确",
          variant: "success",
          position: "bottomCenter",
          offset: 120
        }
      );
    if (s === !1 && n === "submitted")
      return /* @__PURE__ */ r(B, { message: "答案错误", variant: "error" });
  })(),
  /* @__PURE__ */ M(j, { className: "snapshot-ignore", children: [
    /* @__PURE__ */ r(E, { variant: "outlined", onClick: t, children: "返回" }),
    u,
    m == null ? void 0 : m()
  ] })
] }), S = ({
  isRight: l,
  onNext: t,
  onSubmit: e,
  onRetry: o,
  values: m,
  options: u,
  quizAnswer: s
}) => {
  const [n, f] = b("blank"), i = O(() => m.filter((a) => a).length !== s.length, [m, s]), g = O(() => {
    if (n === "submitted") {
      if (l === !0)
        return "success";
      if (l === !1)
        return "error";
    }
  }, [n, l]);
  T(() => {
    l === !0 && f("submitted");
  }, [l]);
  const C = () => {
    f("submitted"), setTimeout(() => {
      const a = m.map((c, d) => {
        const y = u.find((V) => V.text === c);
        return {
          id: (y == null ? void 0 : y.id) || 0,
          number: d + 1,
          text: c
        };
      });
      console.log(a), e == null || e(a);
    }, 400);
  }, h = () => {
    f("blank"), o == null || o();
  }, x = () => {
    t == null || t();
  };
  return [n, f, () => n !== "submitted" ? /* @__PURE__ */ r(E, { variant: "filled", onClick: C, disabled: i, children: "提交" }) : l === !0 ? /* @__PURE__ */ r(E, { variant: "filled", onClick: x, children: "继续" }) : l === !1 ? /* @__PURE__ */ r(E, { variant: "filled", onClick: h, children: "再试一次" }) : /* @__PURE__ */ r(E, { variant: "filled", children: "请稍后..." }), g];
}, A = ({
  options: l,
  userAnswer: t = [],
  quizAnswer: e = [],
  onNext: o,
  onSubmit: m,
  isRight: u,
  ...s
}) => {
  var a;
  const [n, f] = b(
    () => t == null ? void 0 : t.map((c) => c.text)
  );
  T(() => {
    if (e != null && e.length && (t != null && t.length)) {
      const c = e.map((y) => y.text), d = t.map((y) => y.text);
      v.isEqual(c, d) && f(d);
    }
  }, [e, t]);
  const [i, g] = b(
    () => v.shuffle(l)
  ), [C, h, x] = S({
    isRight: u,
    onNext: o,
    values: n,
    quizAnswer: e,
    options: l,
    onSubmit: m,
    onRetry: () => {
      g(v.shuffle(i)), f([]);
    }
  }), p = (c) => {
    C !== "submitted" && (h("selected"), f([c]));
  };
  return /* @__PURE__ */ r(
    k,
    {
      ...s,
      options: l,
      renderAction: x,
      stage: C,
      isRight: u,
      children: /* @__PURE__ */ r(
        H,
        {
          stage: C,
          value: n[0],
          answer: (a = e[0]) == null ? void 0 : a.text,
          onChange: p,
          children: i == null ? void 0 : i.map((c) => /* @__PURE__ */ r(D, { value: c.text, children: c.text }, c.key))
        }
      )
    }
  );
}, F = "_option_wijen_1", G = {
  option: F
}, tt = ({
  options: l,
  userAnswer: t = [],
  quizAnswer: e = [],
  onNext: o,
  onSubmit: m,
  isRight: u,
  ...s
}) => {
  const [n, f] = b(
    () => (t || []).map((a) => a.text)
  ), [i, g] = b(
    () => v.shuffle(l)
  );
  T(() => {
    if (e != null && e.length && (t != null && t.length)) {
      const a = e.map((d) => d.text), c = t.map((d) => d.text);
      v.isEqual(a, c) && f(c);
    }
  }, [e, t]);
  const [C, h, x] = S({
    isRight: u,
    onNext: o,
    values: n,
    quizAnswer: e,
    options: l,
    onSubmit: m,
    onRetry: () => {
      g(v.shuffle(i)), f([]);
    }
  }), p = (a) => {
    C !== "submitted" && (v.includes(n, a) ? f(n.filter((c) => c !== a)) : f(n.concat(a)), h("selected"));
  };
  return /* @__PURE__ */ r(
    k,
    {
      ...s,
      options: l,
      renderAction: x,
      stage: C,
      isRight: u,
      children: i == null ? void 0 : i.map((a) => {
        let c;
        if (n != null && n.length)
          switch (C) {
            case "selected":
              v.includes(n, a.text) && (c = "primary");
              break;
            case "submitted":
              if (e && v.includes(n, a.text)) {
                const d = e.map((y) => y.text);
                v.isEqual(d.sort(), n.sort()) ? c = "success" : c = "error";
              }
              break;
          }
        return /* @__PURE__ */ r(
          D,
          {
            className: G.option,
            value: a.text,
            optionType: "checkable",
            variant: c,
            onClick: () => p(a.text),
            children: a.text
          },
          a.key
        );
      })
    }
  );
}, et = ({
  content: l = "",
  userAnswer: t = [],
  quizAnswer: e = [],
  options: o = [],
  onNext: m,
  onSubmit: u,
  isRight: s,
  ...n
}) => {
  const [f, i] = b(() => {
    if (!t.length || !o)
      return [];
    const a = [];
    return t.forEach((c) => {
      const d = o.find((y) => y.text === c.text);
      d && a.push(d.text);
    }), a;
  });
  T(() => {
    if (e != null && e.length && (t != null && t.length)) {
      const a = e.map((d) => d.text), c = t.map((d) => d.text);
      v.isEqual(a, c) && i(c);
    }
  }, [e, t]);
  const [g, C, h, x] = S({
    isRight: s,
    onNext: m,
    values: f,
    quizAnswer: e,
    options: o,
    onSubmit: u,
    onRetry: () => i([])
  });
  return /* @__PURE__ */ r(
    k,
    {
      ...n,
      options: o,
      renderAction: h,
      stage: g,
      isRight: s,
      children: /* @__PURE__ */ r(
        I,
        {
          mode: "multi-type-in",
          children: l,
          value: f,
          onChange: (a) => {
            g !== "submitted" && i(a);
          },
          options: o,
          variant: x
        }
      )
    }
  );
}, at = ({
  userAnswer: l = [],
  quizAnswer: t = [],
  options: e,
  content: o,
  onNext: m,
  onSubmit: u,
  isRight: s,
  ...n
}) => {
  const [f, i] = b(
    () => l.map((d) => d.text)
  );
  T(() => {
    if (t != null && t.length && (l != null && l.length)) {
      const d = t.map((V) => V.text), y = l.map((V) => V.text);
      v.isEqual(d, y) && i(y);
    }
  }, [t, l]);
  const [g, C] = b(
    () => v.shuffle(e)
  ), [h, x, p, a] = S({
    isRight: s,
    onNext: m,
    values: f,
    quizAnswer: t,
    options: e,
    onSubmit: u,
    onRetry: () => {
      C(v.shuffle(g)), i([]);
    }
  });
  return /* @__PURE__ */ r(
    k,
    {
      ...n,
      options: e,
      renderAction: p,
      stage: h,
      isRight: s,
      children: /* @__PURE__ */ r(
        I,
        {
          options: g,
          mode: "drag-and-drop",
          variant: a,
          children: o || "",
          value: f,
          onChange: (d) => {
            h !== "submitted" && i(d);
          }
        }
      )
    }
  );
}, lt = ({
  content: l = "",
  userAnswer: t = [],
  quizAnswer: e = [],
  options: o = [],
  onNext: m,
  onSubmit: u,
  isRight: s,
  ...n
}) => {
  const [f, i] = b(
    t.map((a) => a.text)
  );
  T(() => {
    if (e != null && e.length && (t != null && t.length)) {
      const a = e.map((d) => d.text), c = t.map((d) => d.text);
      v.isEqual(a, c) && i(c);
    }
  }, [e, t]);
  const [g, C, h, x] = S({
    isRight: s,
    onNext: m,
    values: f,
    quizAnswer: e,
    options: o,
    onSubmit: u,
    onRetry: () => i([])
  });
  return /* @__PURE__ */ r(
    k,
    {
      ...n,
      options: o,
      renderAction: h,
      stage: g,
      isRight: s,
      children: /* @__PURE__ */ r(
        I,
        {
          mode: "single-type-in",
          children: l,
          value: f,
          onChange: (a) => {
            g !== "submitted" && i(a);
          },
          variant: x
        }
      )
    }
  );
}, J = "_card_zum8w_1", K = {
  card: J
}, U = ({ index: l, onMove: t, children: e, ...o }) => {
  const m = N(null), [{ handlerId: u }, s] = L({
    accept: "card",
    collect: (g) => ({
      handlerId: g.getHandlerId()
    }),
    hover(g, C) {
      var y;
      if (!m.current)
        return;
      const h = g.index, x = l;
      if (h === x)
        return;
      const p = (y = m.current) == null ? void 0 : y.getBoundingClientRect(), a = (p.bottom - p.top) / 2, d = C.getClientOffset().y - p.top;
      h < x && d < a || h > x && d > a || (t(h, x), g.index = x);
    }
  }), [{ isDragging: n }, f] = P({
    type: "card",
    item: () => ({ index: l }),
    collect: (g) => ({
      isDragging: g.isDragging()
    })
  }), i = n ? 0 : 1;
  return f(s(m)), /* @__PURE__ */ r(
    "div",
    {
      className: K.card,
      ref: m,
      style: { opacity: i },
      "data-handler-id": u,
      children: /* @__PURE__ */ r(D, { ...o, optionType: "sortable", children: e })
    }
  );
}, _ = (l, t) => {
  const e = v.shuffle([...l]);
  return v.isEqual(
    e.map((o) => o.text),
    t.map((o) => o.text)
  ) ? _(l, t) : e;
}, ct = ({
  options: l,
  userAnswer: t = [],
  quizAnswer: e = [],
  onNext: o,
  onSubmit: m,
  isRight: u,
  ...s
}) => {
  const [n, f] = b(() => t != null && t.length ? l : _(l, e || []));
  T(() => {
    if (e != null && e.length && (t != null && t.length)) {
      const h = e.map((p) => p.text), x = t.map((p) => p.text);
      if (v.isEqual(h, x)) {
        const p = [];
        e.forEach((a) => {
          p.push(l.find((c) => c.id === a.id));
        }), f(p);
      }
    }
  }, [e, t]);
  const [i, , g] = S({
    isRight: u,
    onNext: o,
    values: n.map((h) => h.text),
    quizAnswer: e,
    options: l,
    onSubmit: m,
    onRetry: () => f(_(l, e))
  }), C = (h, x) => {
    i !== "submitted" && f((p) => Y(p, {
      $splice: [
        [h, 1],
        [x, 0, p[h]]
      ]
    }));
  };
  return /* @__PURE__ */ r(
    k,
    {
      ...s,
      options: l,
      renderAction: g,
      stage: i,
      isRight: u,
      children: /* @__PURE__ */ r(Q, { backend: $, children: /* @__PURE__ */ r("div", { children: n.map((h, x) => /* @__PURE__ */ r(
        U,
        {
          index: x,
          onMove: C,
          value: h.text,
          children: h.text
        },
        h.key
      )) }) })
    }
  );
};
export {
  at as DragAndDrop,
  tt as MultiChoice,
  et as MultiTypeIn,
  ct as Reorder,
  A as SingleChoice,
  lt as SingleTypeIn
};
//# sourceMappingURL=index.js.map
